module.exports = __webpack_public_path__ + "images/emoji/grimacing.f1fdd0065a833deb503d.png";